// extracted by mini-css-extract-plugin
module.exports = {"comments":"PhotoComments_comments__KQwdg","single":"PhotoComments_single__1N1Tm"};